<template>
  <div>
    <div class="form-row">
      <div class="form-field">
        <label for="type-name-input">
          Название:
        </label>
        <input
          type="text"
          id="type-name-input"
          v-model="newUserAgreementType.NAME"
        />
      </div>
      <div class="form-field">
        <label for="type-description-input">
          Описание:
        </label>
        <input
          type="text"
          id="type-description-input"
          v-model="newUserAgreementType.DESCRIPTION"
        />
      </div>
      <div class="form-field">
        <label class="typo__label">Фичи интерфейса</label>
        <multiselect
          v-model="newUserAgreementType.AVAILABLE_FEATURES"
          :options="features"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Выберите фичи"
          label="NAME"
          track-by="NAME"
          :preselect-first="true"
        >
          <span slot="noResult">
            Ничего не найдено...
          </span>
        </multiselect>
      </div>
      <div class="form-field">
        <label class="typo__label">Услуги</label>
        <multiselect
          v-model="newUserAgreementType.SERVICES"
          :options="services"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Выберите услуги"
          label="NAME"
          track-by="NAME"
          :preselect-first="true"
        >
          <span slot="noResult">
            Ничего не найдено...
          </span>
        </multiselect>
      </div>
      <div class="form-field">
        <label for="type-penalty-percent-input">
          % пени в день:
        </label>
        <input
          type="text"
          id="type-penalty-percent-input"
          v-model="newUserAgreementType.PENALTY_PERCENT"
        />
      </div>
      <div class="form-field">
        <label for="type-penalty-max-input">
          Лимит пени:
        </label>
        <input
          type="text"
          id="type-penalty-max-input"
          v-model="newUserAgreementType.PENALTY_MAX"
        />
      </div>
      <div class="form-field">
        <label for="type-penalty-descr-input">
          Описание пени:
        </label>
        <input
          type="text"
          id="type-penalty-descr-input"
          v-model="newUserAgreementType.PENALTY_DESCR"
        />
      </div>
      <div class="form-field">
        <button @click="sendAgreementsTypeData">Добавить</button>
      </div>
    </div>
    <div class="form-row" v-if="info">{{ info }}</div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "addAgreementsType",
  data() {
    return {
      url: config.backend_url,
      info: null,
      newUserAgreementType: {
        NAME: null,
        DESCRIPTION: null,
        PENALTY_PERCENT: null,
        PENALTY_MAX: null,
        PENALTY_DESCR: null,
        AVAILABLE_FEATURES: [],
        SERVICES: []
      },
      features: [],
      services: []
    };
  },
  computed: {},
  methods: {
    sendAgreementsTypeData: function() {
      let self = this;
      let availableFeatures = [];
      let availableServices = [];
      this.newUserAgreementType.AVAILABLE_FEATURES.forEach(function(obj) {
        availableFeatures.push(parseInt(obj.ID));
      });
      this.newUserAgreementType.SERVICES.forEach(function(obj) {
        availableServices.push(parseInt(obj.ID));
      });
      this.newUserAgreementType.AVAILABLE_FEATURES = availableFeatures;
      this.newUserAgreementType.SERVICES = availableServices;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "agreementtypelist/add/",
          data: this.newUserAgreementType,
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (data.agreementtypelist) {
            self.info = "Тип соглашения успешно добавлен";
            self.$emit("agreement-type-add");
          }
        });
    },
    getFeatureList: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "featurelist/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.features = Object.values(data);
          }
        });
    },
    getServicesList: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "services/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.services = Object.values(data);
          }
        });
    }
  },
  created() {
    this.getFeatureList();
    this.getServicesList();
  }
};
</script>
